import React, { useState } from 'react';
import Tabs from '../Tabs';
import Panel from '../Panel';
import RequestOverview from './tabs/RequestOverview';
import PossibleMatches from './tabs/PossibleMatches';
import { ApplicationSerializer } from '../../types/campaigns';

interface Props {
  campaignRequest: any;
  patient: any;
  metadata: any;
  application: ApplicationSerializer | null;
  possibleMatchesCount?: number;
  possibleMatches?: any[];
  requestMatches?: any[];
  onPatientUpdate?: (apiResponse: any) => void;
}

const InformationTabs: React.FC<Props> = ({
  campaignRequest,
  patient,
  metadata,
  application: _application,
  possibleMatchesCount = 0,
  possibleMatches = [],
  requestMatches = [],
  onPatientUpdate,
}) => {
  const [openTab, setOpenTab] = useState<number>(1);

  const totalMatchCount = (possibleMatches.length + requestMatches.length) || possibleMatchesCount;

  const tabNames = [
    { name: 'Request Overview' },
    { 
      name: totalMatchCount > 0 
        ? `Possible Matches (${totalMatchCount})` 
        : 'Possible Matches' 
    },
  ];

  return (
    <Panel>
      <Tabs openTab={openTab} setOpenTab={setOpenTab} tabNames={tabNames}>
        {openTab == 1 && (
          <RequestOverview
            campaignRequest={campaignRequest}
            patient={patient}
            metadata={metadata}
            application={_application}
            onUpdate={onPatientUpdate}
          />
        )}
        {openTab == 2 && (
          <PossibleMatches
            campaignRequest={campaignRequest}
            preLoadedMatches={possibleMatches}
            preLoadedRequestMatches={requestMatches}
          />
        )}
      </Tabs>
    </Panel>
  );
};

export default InformationTabs;
